var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-lk-bt-box"},[_c('button',{staticClass:"ui-lk-bt",on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.msg))]),_c('i',{staticClass:"ui-lk-bt-i"})])
}
var staticRenderFns = []

export { render, staticRenderFns }